import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface ExperienceInfoState {
  experienceForms: Array<{
    id: string;
    jobtitle: string;
    companyname: string;
    startdate: string;
    enddate: string;
    description: string;
    isCurrentlyWorking: boolean;
  }>;
}

const initialState: ExperienceInfoState = {
  experienceForms: [],
};

const experienceInfoSlice = createSlice({
  name: 'experienceInfo',
  initialState,
  reducers: {
    setExperienceInfo: (state, action: PayloadAction<ExperienceInfoState>) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setExperienceInfo } = experienceInfoSlice.actions;
export default experienceInfoSlice.reducer; 